import { layer } from "azure-maps-control";

import type { Map, TileLayerOptions } from "azure-maps-control";

type LayerType = "radar" | "satellite" | undefined;
export class AzureWeatherLayer {

  private readonly layerMapping = {
    "radar": "microsoft.weather.radar.main",
    "satellite": "microsoft.weather.infrared.main"
  } as const
  private readonly layer: layer.TileLayer
  private readonly map: Map
  private  layerType: LayerType
  private readonly eventChannel: any;
  // private readonly weatherTileUrl = 'https://{azMapsDomain}/map/tile?api-version=2.0&tilesetId={layerType}&zoom={z}&x={x}&y={y}';
  private readonly weatherTileUrl = 'https://atlas.microsoft.com/map/tile?subscription-key=' + es.azureMapsKey + '&api-version=2.0&tilesetId={layerType}&zoom={z}&x={x}&y={y}';

  constructor(map: Map, layerType: LayerType, eventChannel: any) {

    let options = {
      visible: layerType !== undefined,
      opacity: 0.9,
      tileSize: 256,
    } as TileLayerOptions;

    if (layerType) {
      options.tileUrl = this.weatherTileUrl.replace("{layerType}", this.layerMapping[layerType]);
    }

    this.layer = new layer.TileLayer(options, "weather");
    this.map = map;
    this.layerType = layerType;
    this.eventChannel = eventChannel;

    map.events.add("load", () => {
      // Add layer to the map
      this.map.layers.add(this.layer, "labels");
    });

  }
  getName() {
    return "AzureWeatherLayer" as const;
  }

  reApply() {
    if (this.layer && this.map.layers.getLayerById(this.layer.getId())) {
      this.map.layers.remove(this.layer.getId());
      this.map.layers.add(this.layer);
    }
  }

  hide(): void {
    if (!this.layer) {
      return
    }
    const options = this.layer.getOptions();
    options.visible = false;
    this.layer.setOptions(options);
  }

  updateLayerType(newType: LayerType) {
    if (!this.layer) {
      return;
    }
    this.layerType = newType;

    if (newType) {
      this.setOptions({visible: true, tileUrl: this.weatherTileUrl.replace("{layerType}", this.layerMapping[newType])});
    } else {
      this.hide()
    }
    this.eventChannel.fireEvent("onSetWeatherOverlay", newType);
  }

  getLayerType() {
    return this.layerType;
  }

  show(): void {
    if (!this.layer) {
      return
    }
    const options = this.layer.getOptions();
    options.visible = true;
    this.layer.setOptions(options);
  }

  toggle(): void {
    this.isVisible() ? this.hide() : this.show();
  }

  isVisible(): boolean {
    return this.layer.getOptions().visible ?? false;
  }

  getOptions() {
    return this.layer?.getOptions();
  }

  setOptions(options: TileLayerOptions): void {
    if (!this.layer) {
      return;
    }

    this.layer.setOptions(options);
  }

  destroy(): void {
    if (!this.layer || !this.map.layers.getLayerById(this.layer.getId())) {
      console.error("Map does not contains layer or layer is null.", this.layer?.getId(), this);
      return;
    }
    this.map.layers.remove(this.layer.getId());
  }
}
